





















































































import { Component, Vue, Emit, Prop } from "vue-property-decorator";

import { Dialog, Popup } from "vant";
import axios from "axios";
import { Notify } from "vant";
/* eslint-disable @typescript-eslint/class-name-casing */
/* eslint-disable @typescript-eslint/camelcase */

@Component({
  components: {},
})
export default class EditPodcast extends Vue {
  @Prop() show!: any;

  @Prop() index!: any;
  @Prop() podcast!: any;
  @Prop() Podcasts!: any;
  @Prop() CategoryName!: any;
  categoriesLength: number = 0;
  copyCategory = null;
  errors: any = [];
  apiForNewCategory = "";
  checkRequired() {
    if (this.copyCategory.name) {
      return true;
    }
    this.errors = [];
    if (!this.copyCategory.name) {
      this.errors.push("name required.");
    }
  }

  UpdateFiled() {
    this.podcast.name = this.copyCategory.name;
    this.podcast.shortDescription = this.copyCategory.shortDescription;
    this.podcast.imageUrl = this.copyCategory.imageUrl;
    this.podcast.offlineImageUrl = this.copyCategory.offlineImageUrl;
  }
  UpdateCategory() {
    if (this.checkRequired()) {
      this.UpdateFiled();
      const RequestedData = {
        podcast: this.copyCategory,
      };
      this.apiForNewCategory =
        "https://api.englishjanala.com:8443/v1/englishjanala/podcast/PodcastService/UpdatePodcast";
      const response = axios
        .post(this.apiForNewCategory, RequestedData)
        .then()
        .catch((error) => {
          Notify({ type: "danger", message: "Podcast is not updated" });
        });
      Notify({ type: "success", message: "Podcast updated" });
      this.show = false;
    }
  }

  showPopup() {
    this.show = true;
  }
  mounted() {
    const obj = this.podcast;
    this.copyCategory = Object.assign({}, obj);
    // console.log("copy ", copy); // { a: 1 }
  }
}
